import { useEffect } from "react";

import useToken from "../../../../hooks/auth/useToken";
import {
  isAdminPushConfigured,
  onAdminPushMessage,
  playNotificationSound,
  registerAdminPush,
  showForegroundNotification,
  unlockNotificationAudio,
} from "../../services/adminPushService";

/**
 * Active les notifications push pour l'administrateur connecté.
 *
 * À monter une seule fois, au niveau de la navigation admin, afin que les
 * notifications arrivent quelle que soit la page consultée — et, grâce au
 * service worker, même lorsque le dashboard n'est pas au premier plan.
 */
export default function useAdminChatPush(): void {
  const { token } = useToken();

  useEffect(() => {
    if (!token || !isAdminPushConfigured()) return;

    let cancelled = false;

    registerAdminPush(token).then((status) => {
      if (cancelled) return;
      if (status !== "granted") {
        console.warn(`Notifications admin non activées (${status})`);
      }
    });

    const unlock = () => unlockNotificationAudio();
    window.addEventListener("click", unlock, { once: true });
    window.addEventListener("keydown", unlock, { once: true });

    // Dashboard au premier plan : FCM n'affiche rien de lui-même, on s'en
    // charge et on joue le son.
    const unsubscribe = onAdminPushMessage((message) => {
      playNotificationSound();
      void showForegroundNotification(message);
    });

    return () => {
      cancelled = true;
      unsubscribe();
      window.removeEventListener("click", unlock);
      window.removeEventListener("keydown", unlock);
    };
  }, [token]);
}
